import ChevronRight from "@assets/svg/ChevronRight";
import SearchIcon from "@assets/svg/SearchIcon";
import CallIcon from "@assets/svg/newCall";
import CustomText from "@components/CustomText";
import EmptySearchList from "@components/SearchHeader/EmptySearchList";
import color from "@constants/color";
import { meta } from "@constants/cplp";
import { colors } from "@constants/theme";
import { useFocusEffect, useIsFocused } from "@react-navigation/native";
import HeaderWithSearch from "@screens/MyDeliveries/HeaderWithSearch";
import NoBag from "@assets/svg/NoBag";
import {
  addToBag,
  getDeliveryOrderItems,
  markAction,
  markMyDeliveyModalAction,
} from "@services/api";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import debounce from "lodash/debounce";
import React, { useCallback, useMemo, useState } from "react";
import {
  ActivityIndicator,
  Modal,
  SectionList,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import MarkingInfoModal from "@screens/MyDeliveries/components/MarkingInfoModal";
// eslint-disable-next-line import/no-named-as-default
import t from "@constants/localization";
import { appEnv } from "@config";
import CrateItem from "@screens/CustomerOrderItems/components/CrateCard";
import InfoLines from "@screens/CustomerOrderItems/components/InfoModal/InfoLines";
import BottomButton from "@screens/MyDeliveries/SortingDeliveries/components/BottomButton";
import AddBagNoModal from "@screens/MyDeliveries/SortingDeliveries/components/AddBagNoModal";
import InfoModal from "@screens/CustomerOrderItems/components/InfoModal";
import ShipmentCard from "@screens/CustomerOrderItems/components/ShipmentCard";
import {
  checkCanMarkAllQuantity,
  checkIfAllDefective,
} from "@screens/MyDeliveries/utils";

const COLORS = {
  plasticBagBg: "#FFF9E6",
  plasticBagText: "#B45309",
};

function getCrateOrShipmentItem(type) {
  return type === "CRATE" || type === "OTHER_CRATE" || type === "PACKED_ORDERS"
    ? CrateItem
    : ShipmentCard;
}

function SortingItemList({ navigation, route }) {
  const getDeliveryOrderItemsApi = getDeliveryOrderItems;

  const isFocused = useIsFocused();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ordersItem, setOrdersItem] = useState([]);
  const [fullOrdersItem, setFullOrdersItem] = useState([]);
  const [markingConfig, setMarkingConfig] = useState([]);
  const [markingConfigs, setMarkingConfigs] = useState({});
  const [meteData, setMetaData] = useState({});
  const [searchEnable, setSearchEnable] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showConfirmSubmitModal, setShowConfirmSubmitModal] = useState(false);
  const [infoItemState, setInfoItemState] = useState(null);
  const [buttonPress, setButtonPress] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [showBagModal, setShowBagModal] = useState(false);
  const [bagModalError, setBagModalError] = useState("");
  const [bagBtnLoading, setBagBtnLoading] = useState(false);
  const [isOfdCp, setIsOfdCp] = useState(false);
  const [plasticBagCount, setPlasticBagCount] = useState(0);
  const [imagesMandatoryForSamasya, setImagesMandatoryForSamasya] = useState(
    {},
  );

  const PATH = "screens/MyDeliveries/SortingDeliveries/sortingItemList";

  useFocusEffect(
    useCallback(() => {
      if (isFocused || showBagModal) {
        fetchData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFocused, showBagModal]),
  );

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const { data } = await getDeliveryOrderItemsApi({
        order_ids: route?.params?.orders_list,
        fragile_order_ids: route?.params?.fragile_order_ids,
        top_sku_order_ids: route?.params?.top_sku_order_ids,
        spoke_name: route?.params?.spokeName || "",
        user_id: route?.params?.user_id,
        date: route?.params?.date || "",
        source: "SORTING",
      });
      setOrdersItem(data?.data);
      setMarkingConfig(data?.marking_config);
      setMarkingConfigs(
        data?.marking_configs || { default: data?.marking_config || [] },
      );
      setMetaData(data?.meta);
      setFullOrdersItem(data?.data);
      setShowConfirmSubmitModal(data?.show_confirmSubmitModal);
      setInfoItemState(data?.item_info_state);
      setShowSubmit(data?.showSubmitButton);
      setIsOfdCp(data?.is_ofd_cp);
      setImagesMandatoryForSamasya(data?.images_mandatory_for_samasya);
      setPlasticBagCount(data?.plastic_bag_count || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setIsRefreshing(false);
      setIsLoading(false);
    }
  };

  const onRefresh = () => {
    setIsRefreshing(true);
    fetchData();
  };

  const sortUpdates = useMemo(() => {
    return ordersItem.map((v) => {
      return {
        ...v,
        data: v.items,
      };
    });
  }, [ordersItem]);
  const handleAddToBag = async (bags) => {
    const order_item_ids = [];
    ordersItem.forEach((v) => {
      if (v?.items && Array.isArray(v.items)) {
        v.items.forEach((i) => {
          if (i?.order_item_id) {
            order_item_ids.push(i.order_item_id);
          }
        });
      }
    });
    const newBags = Array.from(new Set(bags.filter((v) => v !== "")));
    setBagBtnLoading(true);
    try {
      const payload = {
        unique_key: route?.params?.unique_key || "",
        shipment_ids: route?.params?.shipment_ids || [""],
        cx_id: route?.params?.user_id || "",
        order_ids: route?.params?.orders_list || [],
        route_id: route?.params?.route_id || "",
        old_bags: route?.params?.bags || [],
        new_bags: newBags || [],
        type: route?.params?.type || "",
        order_item_ids,
        bags_disabled: route?.params?.bags_disabled,
        cx_packing_enabled: route?.params?.cx_packing_enabled,
      };
      await addToBag(payload);
      navigation.replace("CrateCustomerList", {
        crate: route?.params?.crate,
        spoke: route?.params?.spokeName,
        date: route?.params?.date,
        type: route?.params?.type,
        from: "SortingItemList",
      });
      setShowBagModal(false);
    } catch (error) {
      setBagModalError(error.response?.data?.message);
    } finally {
      setBagBtnLoading(false);
    }
  };

  const renderItem = useCallback(
    ({ item, section }) => {
      const itemBgStyle =
        section?.type === "OTHER_CRATE"
          ? styles.otherCrateBg
          : section?.type === "TOP_SKU"
            ? styles.topSkuBg
            : styles.whiteBg;
      const CrateOrShipmentItem = getCrateOrShipmentItem(section?.type, false);
      const itemMarkingConfig =
        markingConfigs[item.marking_config_type] ||
        markingConfigs.default ||
        markingConfig;
      return (
        <View style={itemBgStyle}>
          <CrateOrShipmentItem
            info={item}
            markingConfig={itemMarkingConfig}
            fetchData={fetchData}
            imagesMandatoryForSamasya={imagesMandatoryForSamasya}
            source="SORTING"
            isOfdCp={isOfdCp}
            type={section?.type}
          />
        </View>
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [imagesMandatoryForSamasya],
  );

  const renderSection = ({ section: { type, data, display_type } }) => {
    const sectionTitle =
      display_type === "CRATE"
        ? meta.crate_item_label
        : display_type === "OTHER_CRATE"
          ? meta.other_crate_label
          : display_type === "SKU_WISE_ORDER_ITEMS"
            ? meta.sku_wise_order_items_label
            : display_type === "TOP_SKU"
              ? meta.top_sku_items_label
              : display_type === "PACKED_ORDERS"
                ? meta.packed_orders
                : meta.shipment_label;

    return data.length ? (
      <View
        style={[
          styles.sectionContainer,
          type === "OTHER_CRATE" && styles.otherCrateSection,
          type === "TOP_SKU" && styles.topSkuSection,
        ]}
      >
        <CustomText variant="body_text_2" style={styles.sectionTitle}>
          {sectionTitle}
        </CustomText>
      </View>
    ) : null;
  };

  const keyExtractor = (item, index) => `${item.id}_${index}`;

  const seeOrders = () => {
    if (route?.params?.orders_list.length === 1) {
      navigation.navigate("OrderDetails", {
        order_id: route?.params?.orders_list[0],
      });
    } else {
      navigation.navigate("DailyOrderList", {
        user_id: route?.params?.user_id,
        user_name: route?.params?.user_name,
        date: route?.params?.date,
        type: route?.params?.type,
      });
    }
  };

  const subHeadingComponent = useMemo(
    () => (
      <TouchableOpacity testID="see_orders" onPress={seeOrders}>
        <View style={styles.subHeadingRow}>
          <CustomText variant="body_text_4" style={styles.seeOrdersText}>
            {t(`${PATH}/seeOrders`)}
          </CustomText>
          <ChevronRight
            pathFill={color.borderColor}
            style={styles.chevronIcon}
          />
        </View>
      </TouchableOpacity>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [route?.params?.orders_list],
  );

  const rightComponent = useMemo(
    () => (
      <View style={styles.rightComponentRow}>
        <View>
          <TouchableOpacity
            testID="user_phone"
            onPress={() => onPressCall(route?.params?.user_phone)}
          >
            <CallIcon strokeColor="#2195F2" />
          </TouchableOpacity>
        </View>
        <View style={styles.searchIconContainer}>
          <TouchableOpacity
            testID="search_enable"
            onPress={() => setSearchEnable(true)}
          >
            <SearchIcon height={20} width={20} />
          </TouchableOpacity>
        </View>
      </View>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [route?.params?.user_phone],
  );

  const onPressCall = (phone) => {
    handleCallButtonPress(phone, "CX_NUMBER_CLICKED", {
      type: "call",
      user_id: route?.params?.user_id,
      user_name: route?.params?.user_name,
      orders: route?.params?.orders_list,
    });
  };

  const onPressCrossIcon = () => onSearchInputChange("");

  const onSearchInputChange = debounce((text) => {
    const filteredData = fullOrdersItem.map((data) => {
      return {
        ...data,
        items: data?.items?.filter((v) =>
          containText(text, v?.product_name_en),
        ),
      };
    });
    setOrdersItem(filteredData);
  }, 500);

  const shouldShowModal = () => {
    return infoItemState === "MODAL";
  };

  const containText = (text, item) => {
    const lowerCasedText = text?.trim().toLowerCase();
    return item?.toLowerCase().includes(lowerCasedText);
  };

  const getListHeaderComponent = () => {
    return (
      <>
        {route?.params?.route_name ? (
          <View style={styles.headerContainer}>
            <View style={styles.headerContent}>
              <View style={styles.avatarContainer}>
                <CustomText variant="subtitle_16" style={styles.avatarText}>
                  {route?.params?.db_name?.charAt(0).toUpperCase() || "U"}
                </CustomText>
              </View>
              <View>
                <CustomText variant="body_text_3" style={styles.routeName}>
                  {route?.params?.route_name}
                </CustomText>
                <CustomText
                  variant="subtitle_16"
                  style={{
                    color:
                      route?.params?.db_name === "UNASSIGN"
                        ? color.mediumBlacklightBlack
                        : color.black,
                  }}
                >
                  {route?.params?.db_name || "Unassigned"}
                </CustomText>
              </View>
            </View>
            <View style={styles.bagsContainer}>
              {Array.isArray(route?.params?.bags) &&
              route?.params?.status === "PACKED" &&
              route?.params?.bags.every((bag) => bag === "") ? (
                <NoBag />
              ) : (
                route?.params?.bags?.map((i, index) => (
                  <CustomText
                    key={`bag-${index}`}
                    variant="heading_24"
                    numberOfLines={1}
                    style={
                      index === route?.params?.bags?.length - 1
                        ? styles.bagTextLast
                        : styles.bagText
                    }
                  >
                    {index === route?.params?.bags?.length - 1 ? i : `${i}, `}
                  </CustomText>
                ))
              )}
            </View>
          </View>
        ) : null}
        {plasticBagCount > 0 && (
          <View style={styles.plasticBagBanner}>
            <CustomText variant="body_text_2" style={styles.plasticBagText}>
              {`${plasticBagCount} पॉली बैग ज़रूरी। कृपया इस ऑर्डर को पॉली बैग में डिलीवर करें।`}
            </CustomText>
          </View>
        )}
        <InfoLines
          info={meteData?.InfoModal}
          state={infoItemState}
          onPress={onPressCut}
        />
      </>
    );
  };

  const onPressCut = async () => {
    if (buttonPress) {
      return;
    }
    setButtonPress(true);
    await markMyDeliveyModalAction("item_info_IN_SCREEN");
    await fetchData();
    setButtonPress(false);
  };

  const footerComponent = () => <View style={styles.footerSpacer} />;

  const checkItemDatailsEmpty = () => {
    return !sortUpdates.find((v) => v?.data?.length > 0);
  };

  const onSubmitConfirmModal = async () => {
    if (buttonPress) {
      return;
    }
    setButtonPress(true);
    const { user_id = "", spokeName = "", date = "" } = route?.params || {};
    const action = `confirm_submit_modal_${user_id}_${spokeName}_${date}`;
    await markAction(action);
    fetchData();
    setVisible(false);
    setButtonPress(false);
  };

  const onSubmit = async () => {
    if (buttonPress) {
      return;
    }
    setButtonPress(true);
    await markMyDeliveyModalAction("item_info_IN_SCREEN");
    await fetchData();
    setButtonPress(false);
  };

  return (
    <View style={styles.container}>
      <HeaderWithSearch
        headertitle={`${route?.params?.user_name} जी का ऑर्डर`}
        headerColor="#fff"
        hideShadow={false}
        isSearchEnabled={searchEnable}
        navigation={navigation}
        route={route}
        rightComponent={rightComponent}
        subHeadingComponent={
          appEnv === "production" ? (
            <View style={styles.subHeadingSpacer} />
          ) : (
            subHeadingComponent
          )
        }
        onPressCrossIcon={onPressCrossIcon}
        onSearchInputChange={onSearchInputChange}
        searchPlaceholder={t(`${PATH}/itemSearchPlaceholder`)}
      />
      {checkItemDatailsEmpty() ? (
        <EmptySearchList />
      ) : (
        <>
          <View style={styles.listContainer}>
            <SectionList
              renderSectionHeader={renderSection}
              ListHeaderComponent={getListHeaderComponent}
              keyExtractor={keyExtractor}
              contentContainerStyle={styles.listContentContainer}
              sections={sortUpdates}
              renderItem={renderItem}
              keyboardShouldPersistTaps="handled"
              ListFooterComponent={footerComponent}
              onRefresh={onRefresh}
              refreshing={isRefreshing}
            />
          </View>
          {showSubmit ? (
            checkIfAllDefective(ordersItem) ||
            route?.params?.bags_disabled ||
            route?.params?.cx_packing_enabled ? (
              <BottomButton
                onPress={() => {
                  handleAddToBag([]);
                }}
                title={t(`${PATH}/submit`)}
              />
            ) : (
              <BottomButton
                onPress={() => {
                  if (
                    showConfirmSubmitModal &&
                    !checkCanMarkAllQuantity(fullOrdersItem)
                  ) {
                    setVisible(true);
                    return;
                  }
                  setShowBagModal(true);
                }}
                title={
                  route?.params?.bags?.length &&
                  route?.params?.bags.every((bag) => bag !== "")
                    ? t(`${PATH}/changeBagNumber`)
                    : t(`${PATH}/addBagNumber`)
                }
              />
            )
          ) : (
            <></>
          )}
        </>
      )}
      <AddBagNoModal
        visible={showBagModal}
        onClose={() => {
          setShowBagModal(false);
          setBagModalError("");
        }}
        item={route?.params}
        onSave={handleAddToBag}
        error={bagModalError}
        btnLoading={bagBtnLoading}
      />
      <InfoModal
        visible={shouldShowModal()}
        info={meteData?.InfoModal}
        onSubmit={onSubmit}
      />
      <MarkingInfoModal
        onSubmit={onSubmitConfirmModal}
        visible={visible}
        data={meteData?.ConfirmSubmitModal}
      />
      <Modal visible={isLoading} transparent={true}>
        <View style={styles.loadingView}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.black02,
  },
  sectionContainer: {
    padding: 12,
    backgroundColor: color.white,
    paddingLeft: 16,
  },
  sectionTitle: { color: color.black },
  topSkuSection: {
    backgroundColor: color.topSkuSectionBg,
    borderStyle: "dashed",
    borderTopWidth: 1,
  },
  avatarContainer: {
    height: 35,
    width: 35,
    borderRadius: 20,
    marginRight: 8,
    backgroundColor: colors.black,
    justifyContent: "center",
    alignItems: "center",
  },
  avatarText: {
    color: colors.white,
  },
  headerContainer: {
    backgroundColor: color.headerBg,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: 16,
  },
  headerContent: {
    flexDirection: "row",
    alignItems: "center",
  },
  bagsContainer: {
    maxWidth: "50%",
    overflow: "hidden",
    flexDirection: "row",
    alignItems: "center",
  },
  plasticBagBanner: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: COLORS.plasticBagBg,
    margin: 8,
    borderRadius: 6,
  },
  plasticBagText: { color: COLORS.plasticBagText },
  otherCrateSection: {
    backgroundColor: color.otherCrateBg,
    borderStyle: "dashed",
    borderTopWidth: 1,
  },
  otherCrateBg: {
    backgroundColor: color.otherCrateBg,
  },
  topSkuBg: {
    backgroundColor: color.topSkuSectionBg,
  },
  whiteBg: {
    backgroundColor: color.white,
  },
  routeName: {
    color: colors.mediumBlacklightBlack,
    top: 5,
  },
  footerSpacer: {
    height: 240,
    backgroundColor: color.white,
  },
  listContainer: {
    flex: 1,
  },
  listContentContainer: {
    marginTop: 8,
    paddingBottom: 80,
  },
  subHeadingRow: {
    flexDirection: "row",
  },
  seeOrdersText: {
    color: color.mediumBlacklightBlack,
    textDecorationLine: "underline",
  },
  chevronIcon: {
    height: 14,
    width: 14,
    marginTop: 2,
    marginLeft: 4,
  },
  rightComponentRow: {
    flexDirection: "row",
    top: 10,
  },
  searchIconContainer: {
    marginLeft: 24,
  },
  subHeadingSpacer: {
    height: 15,
  },
});

export default SortingItemList;
